import { Configuration, FrontendApi } from '@ory/client-fetch';
import { edgeConfig } from '@ory/integrations/next';

let oryInstance: FrontendApi | null = null;

/**
 * Returns a singleton instance of the Ory Frontend API client
 */
const getOry = (): FrontendApi => {
  if (!oryInstance) {
    oryInstance = new FrontendApi(
      new Configuration({
        ...edgeConfig,
        headers: {
          Accept: 'application/json',
        },
      }),
    );
  }

  return oryInstance;
};

export { getOry };
